export default {
    bindings: {
        isGlobal: '<',
        isRevenue: '<'
    },
    controller: 'dashboardController',
    template: require('../views/revenue.dashboard.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/dashboard/components/revenue.dashboard.component.js